import { render, staticRenderFns } from "./objection.vue?vue&type=template&id=051498bd&scoped=true"
import script from "./objection.vue?vue&type=script&lang=js"
export * from "./objection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051498bd",
  null
  
)

export default component.exports